import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

/** Route `data` flag: a navigation to the same route with other params builds a new component. */
export const RECREATE_ON_PARAM_CHANGE = 'recreateOnParamChange';

/**
 * Angular keeps a component when only its params change. A page that reads its id once (the deal room reads
 * `:id` in `ngOnInit` and binds its saves, history and CRM log to it) then shows the room it was opened for
 * under another room's URL, and its edits go to the wrong room. A route marked `recreateOnParamChange` is not
 * reused across params; every other route keeps Angular's default.
 */
@Injectable()
export class RecreateOnParamChangeStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (!super.shouldReuseRoute(future, curr)) return false;
    if (!future.routeConfig?.data?.[RECREATE_ON_PARAM_CHANGE]) return true;
    const keys = new Set([...Object.keys(future.params), ...Object.keys(curr.params)]);
    return [...keys].every(key => future.params[key] === curr.params[key]);
  }
}
